// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { UserOutlined, AppstoreAddOutlined, AuditOutlined } from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
    UserOutlined,
    AppstoreAddOutlined,
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const applications: NavItemType = {
    id: 'group-applications',
    title: <FormattedMessage id="applications" />,
    icon: icons.AppstoreAddOutlined,
    type: 'group',
    allowedGroups: [],
    children: [
        {
            id: 'user-list',
            title: 'Users',
            type: 'item',
            url: '/user/all',
            icon: UserOutlined,
            allowedGroups: [],
        },
        {
            id: 'accreditation-list',
            title: 'Accreditation',
            type: 'item',
            url: '/accreditation/all',
            icon: AuditOutlined,
            allowedGroups: [],
        },
    ],
};

export default applications;
